var React = require('react');

function PlayIconInline (props) {
    return React.createElement("svg",props,React.createElement("polygon",{"points":"5.71 100 94.29 50 5.71 0 5.71 100"}));
}

PlayIconInline.defaultProps = {"height":"100px","width":"100px","viewBox":"0 0 100 100","x":"0px","y":"0px"};

module.exports = PlayIconInline;

PlayIconInline.default = PlayIconInline;
